import { CompletePerson } from '@/app/models/person';
import AddIcon from '@mui/icons-material/Add';
import {
  IconButton,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const HeaderTableCell = styled(TableCell)(() => ({
  fontSize: 13,
  justifyContent: 'space-between',
  fontWeight: 'bold',
}));

const RowTableCell = styled(TableCell)(() => ({
  fontSize: 13,
  justifyContent: 'space-between',
}));

type NoSharingTableParams = {
  rows: CompletePerson[];
  setDrawerStatus: (b: boolean) => void;
  setSelectedItem: (c: CompletePerson) => void;
};

export default function NoSharingTable(props: NoSharingTableParams) {
  const { t } = useTranslation(['noSharing', 'common']);
  const { rows, setDrawerStatus, setSelectedItem } = props;

  return (
    <TableContainer sx={{ marginLeft: 0, padding: 0, width: '100%' }}>
      <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
        <TableHead>
          <TableRow>
            <HeaderTableCell colSpan={2}>{t('common:collaborator')}</HeaderTableCell>
            <HeaderTableCell>{t('common:resource.badge')}</HeaderTableCell>
            <HeaderTableCell align="right">{t('common:actions')}</HeaderTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <RowTableCell colSpan={2}>{row.name}</RowTableCell>
              <RowTableCell>{row.badge}</RowTableCell>
              <RowTableCell align="right">
                <Tooltip title={t('add.sharing')}>
                  <IconButton
                    sx={{ padding: '0px' }}
                    onClick={() => {
                      setDrawerStatus(true);
                      setSelectedItem(row);
                    }}
                  >
                    <AddIcon sx={{ color: '#4B4B4B', padding: '0px' }} fontSize="small" />
                  </IconButton>
                </Tooltip>
              </RowTableCell>
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell sx={{ textAlign: 'center' }} colSpan={4}>
                <Typography variant="subtitle2">
                  {t('common:no.data.for.the.chosen.period.and.search.term')}
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
